<template>
  <iframe title="Live betting" class="liveBettingIframe" src="https://plive.jazzsports.ag/live/?skin=viperlines#!/sport/2" width="100%" height="900" frameborder="no" style="border:none;"></iframe>
</template>

<script>
  export default {
    name: "apuestasPage",

    setup:() => {
      const BackEndUrl = "juegayaa.com";
      
      return {
        BackEndUrl,
      }
    },
  }
</script>